export const config = {
  monitoring: {
    titleMonitoring: 'Monitoring',
    subtitleMonitoring:
      'To ensure transparent workflow and efficient execution of the client’s AI diagnosing project, each augmentation specialist was monitored by a personal manager whose role consisted in meticulous tracking of the expert’s daily working tasks and hours through our internal employee management system and observation of one’s mental state to avoid efficiency dropping and burnout, inevitably leading to project development quality losses.',
  },
  reporting: {
    titleReporting: 'Reporting',
    subtitleReporting:
      'Throughout the cooperation period, Modsen augmentation team members were asked to submit weekly progress reports to showcase the project’s advancements and adapt to evolving requirements and emerging tasks assigned directly by our partner.',
  },
  reportingImage: {
    src: '/images/cases/healthcare-ai-based-platformhalthcare-ai-based-platform.webp',
    alt: 'AI-based platform interface',
    title: 'AI-based platform interface',
    width: 762,
    height: 572,
  },
}
